module.exports = __webpack_public_path__ + "static/img/notice-dialog-icon.4cbbbf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/notice-dialog-icon.png
// module id = SOFz
// module chunks = 0